module.exports = __webpack_public_path__ + "img/joana.385964e4.jpg";